import { getApiBase, resetApiBase, resolveApiBase } from '../config/runtime';

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  const base = getApiBase();

  const res = await fetch(`${base}${path}`, { ...options, headers });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    if (text.includes('<!DOCTYPE') || text.includes('<html')) {
      const err = new Error(
        `API unavailable at ${base}${path}. Check public/runtime-config.json or REACT_APP_API_URL.`
      );
      err.status = res.status;
      throw err;
    }
  }

  if (!res.ok) {
    const err = new Error(data.error || 'Request failed');
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export const api = {
  getDonationMethods: () => request('/donation-methods'),

  getDonationProjects: () => request('/projects?type=DONATION'),

  getInvestmentProjects: () => request('/projects?type=INVESTMENT'),

  getProjects: () => request('/projects'),

  getContributionTotals: () => request('/contributions/totals'),

  getHeroVideo: () => request('/site/hero-video'),

  submitContribution: (body) =>
    request('/contributions', { method: 'POST', body: JSON.stringify(body) }),

  reconnect: () => {
    resetApiBase();
    return resolveApiBase(true);
  },
};
